import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './Curtains.module.scss';
import { CurtainsDecorDetails } from "./CurtainsConstant";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import defaultImage from '../../../assets/default.png';

const CurtainsDecor = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  const panelDetails = updatedValues?.curtainsDetails?.length ? updatedValues?.curtainsDetails : CurtainsDecorDetails;

  return (
    <section className={style.curtains_room_container}>
      <h2 className="section_heading">{updatedValues?.name}</h2>
      <div className={style.curtains_details_tabs}>
        <div className={style.curtains_work_image_columns}>
          <section style={{ gridTemplateRows: '1fr max-content 1fr' }}>
            <div className={style.left_image_section}>
              <p>Key Plan of the House / <br /> Site Photograph of the Room</p>
            </div>
            <hr />
            <div className={style.left_image_section}>
              {updatedValues?.images?.length ? <img crossOrigin="anonymous" src={updatedValues?.images[0] ? `${updatedValues?.images[0]}?ver=${new Date().getTime()}`: defaultImage} alt="" style={{ maxHeight: updatedValues?.images?.length > 1 ? '170px' : '190px' }} className="image-view" /> : <p>Fabric Image(s)</p>}
            </div>
          </section>
          <section>
            <div>
              <p>Window Elevation with</p>
              <p>a) Overall Window Dimensions (X & Y Axis); </p>
              <p>b) Overall Curtain Dimensions (X+10" & Y+10")</p>
              <span>Designer to denote each panel as (Panel Code A,B, C, D etc.) with Legend Below:</span>
              <p>Panel A: Panel Dimension: Panel Size (Width & Height): Panel Fabric</p>
            </div>
            {
              updatedValues?.curtainsDetails?.some((e: any) => e?.designType) ? (
                <div className={style.right_image_section}>
                  {updatedValues?.curtainsDetails?.map((e: any, i: number) => (
                    <img key={i} crossOrigin="anonymous" src={e?.designType ? `${e?.designType}?ver=${new Date().getTime()}` : defaultImage} alt="" style={{ maxHeight: '170px' }} className="image-view" />
                  ))}
                </div>
              ) : ''
            }
          </section>
        </div>
        <div className={style.curtains_item_container}>
          <h2 className="sub_tab_heading">{updatedValues?.curtainsDetails?.[0]?.heading ? updatedValues?.curtainsDetails?.[0]?.heading : 'Curtains Details'}</h2>
          <div className={style.demolition_item_details_panel}>
            <div className={style.curtains_details_tabs_4_col}>
              <h4>Product Name</h4>
              <h4>Wall Orientation</h4>
              <h4>Quantity</h4>
              <h4>Rod Length</h4>
            </div>
            <div className={`${style.curtains_items_list} ${style.curtains_details_tabs_4_col}`}>
              {
                panelDetails?.map((e, i) => (
                  <>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || ''} onChange={(v) => updateItems({ id: `fabric_name_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`wall_orientation_${i}`] || e?.[`wall_orientation_${i}`] || ''} onChange={(v) => updateItems({ id: `wall_orientation_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`wall_orientation_${i}`] || e?.[`wall_orientation_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || ''} onChange={(v) => updateItems({ id: `quantity_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`length_${i}`] || e?.[`length_${i}`] || ''} onChange={(v) => updateItems({ id: `length_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`length_${i}`] || e?.[`length_${i}`] || '-'}</span>}
                      </div>
                    </p>

                  </>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CurtainsDecor;